<template>
  <AccountExists
    :first-name="firstName"
    :last-name="lastName"
    @logIn="logIn"
    @back="back"
  />
</template>

<script>
export default {
  name: 'AccountExistsWidget',
  data() {
    return {
      firstName: undefined,
      lastName: undefined
    };
  },
  methods: {
    async logIn() {
      this.$router.push({
        name: this.$auth.isAuthenticated
          ? this.$RouteNames.dashboard
          : this.$RouteNames.login
      });
    },
    back() {
      this.$router.push({ name: this.$RouteNames.signUp });
    }
  },
  mounted() {
    this.firstName = this.$route.query.firstName;
    this.lastName = this.$route.query.lastName;
  },
  components: {
    AccountExists: () => import('../../components/page/account-exists')
  }
};
</script>
